import { CustomerAssignedVoucher } from 'src/app/stores/stores';
import { copyToClipboard } from './clipboard.util';

export function normalizeVoucherCode(
  voucherCode: string | null | undefined,
): string | null {
  const trimmedVoucherCode = (voucherCode || '').trim();
  if (!trimmedVoucherCode) {
    return null;
  }

  return trimmedVoucherCode.toUpperCase();
}

export interface FormatVoucherValueOptions {
  currencyIsoCode?: string;
  currencySymbol?: string;
}

export function formatVoucherValue(
  voucher: CustomerAssignedVoucher,
  options: FormatVoucherValueOptions = {},
): string {
  if (voucher.formattedDiscount) {
    return voucher.formattedDiscount;
  }

  if (voucher.discountType === 'PERCENTILE') {
    return `${voucher.discount}%`;
  }

  const { currencyIsoCode, currencySymbol } = options;
  if (currencySymbol) {
    return `${currencySymbol}${voucher.discount}`;
  }
  if (currencyIsoCode) {
    return `${voucher.discount} ${currencyIsoCode}`.trim();
  }
  return `${voucher.discount}`;
}

export function isVoucherUnavailable(
  voucher: CustomerAssignedVoucher,
): boolean {
  const endDate = voucher.endDate ? new Date(voucher.endDate) : null;
  return (
    !voucher.isActive ||
    voucher.discount === 0 ||
    voucher.isConsumed ||
    (!!endDate && endDate < new Date())
  );
}

export function getVoucherCodeFromUrl(
  search: string,
  hash: string = '',
): string | null {
  const searchVoucherCode = normalizeVoucherCode(
    new URLSearchParams(search).get('voucher'),
  );
  if (searchVoucherCode) {
    return searchVoucherCode;
  }

  const fragmentQuery = hash?.split('?')[1];
  if (!fragmentQuery) {
    return null;
  }

  return normalizeVoucherCode(
    new URLSearchParams(fragmentQuery).get('voucher'),
  );
}

/**
 * Copies voucher code to clipboard with proper error handling.
 */
export function copyVoucherCodeToClipboard(code: string): void {
  copyToClipboard(code);
}
